module.exports = __webpack_public_path__ + "static/quality_care-26e973e1bb919ce2fa839809ff55b542.png";